module.exports = __webpack_public_path__ + "img/5add79e.png";